// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1GR78","author":"Table_author__22qQt","authorImage":"Table_authorImage__2UkX4","unreadRow":"Table_unreadRow__2t7G5"};